









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryDistributionActivityList, UpdateDistributionActivityStatus } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditDistributionActivityDialog from './EditDistributionActivityDialog.vue'
import { MemberStatusFormat,MemberIsDemotionFormat,DistributionActivityTypeFormat,DistributionActivityNumberTypeFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
    EditDistributionActivityDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '绿豆发放名称', param: 'name' },
        { title: '状态', param: 'status', type: 'select', selectData: constant.MemberStatus },

  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建绿豆发放', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '绿豆发放名称', param: 'name' },
    { title: '金额类型', param: 'numberType',formatter: DistributionActivityNumberTypeFormat },
    { title: '金额', param: 'totalNumber' },
    { title: '分配类型', param: 'type',formatter: DistributionActivityTypeFormat ,width:120},
    { title: '合伙人分红', param: 'isPartnerDistribution',formatter: MemberIsDemotionFormat,width:120},
    { title: '状态', param: 'status' , formatter: MemberStatusFormat},
    { title: '开始时间', param: 'startTime',formatter: DateFormat,width:160 },
    { title: '结束时间', param: 'endTime',formatter: DateFormat,width:160 },
    { title: '执行间隔', param: 'distributionInterval' },
    { title: '下次执行时间', param: 'distributionTime',formatter: DateFormat,width:160 },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        {
          title: '启用',
          click: this.updateOpenStatus,
          show: function (data) {
            return data.status != 1
          },
        },
        {
          title: '禁用',
          click: this.updateCloseStatus,
          show: function (data) {
            return data.status == 1
          },
        },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo() {
    const d = this.$refs.EditDistributionActivityDialog as EditDistributionActivityDialog
    d.open({}, false)
  }

  private async updateOpenStatus(data: any) {
    await UpdateDistributionActivityStatus({
      id: data.id,
      status: 1,
    })
    this.loadData()
  }
  private async updateCloseStatus(data: any) {
    await UpdateDistributionActivityStatus({
      id: data.id,
      status: 0,
    })
    this.loadData()
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditDistributionActivityDialog as EditDistributionActivityDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryDistributionActivityList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
